import * as firebase from "firebase/app"
import { getFirestore } from 'firebase/firestore';


const firebaseConfig = {
    apiKey: "AIzaSyCmMHgWEvgcoHEiKykr9mErYwwLJTakixU",
    authDomain: "mobijob-af21d.firebaseapp.com",
    projectId: "mobijob-af21d",
    storageBucket: "mobijob-af21d.appspot.com",
    messagingSenderId: "576103263410",
    appId: "1:576103263410:web:6d8ebbceb75c75ca622dab"
  };

const app = firebase.initializeApp(firebaseConfig);
const db = getFirestore(app);


export { db }  